// Общие функции для стилизации dot-элементов
export const dotChannel = () => ({
  display: 'flex',
  ':before': {
    borderRadius: 10,
    content: '"Канал:"',
    display: 'block',
    marginRight: 45,
    height: 10,
    width: 10,
  },
});

export const dotDepartment = () => ({
  display: 'flex',
  ':before': {
    borderRadius: 10,
    content: '"Подразделение:"',
    display: 'block',
    marginRight: 120,
    height: 10,
    width: 10,
  },
});

export const dotCustomer = () => ({
  display: 'flex',
  ':before': {
    borderRadius: 10,
    content: '"Заказчик:"',
    display: 'block',
    marginRight: 70,
    height: 10,
    width: 10,
  },
});

export const dotStatus = () => ({
  display: 'flex',
  ':before': {
    borderRadius: 10,
    content: '"Вакансии:"',
    display: 'block',
    marginRight: 70,
    height: 10,
    width: 10,
  },
});

export const dotRecruiter = () => ({
  display: 'flex',
  ':before': {
    borderRadius: 10,
    content: '"Рекрутеры:"',
    display: 'block',
    marginRight: 80,
    height: 10,
    width: 10,
  },
});

// Общие стили для react-select компонентов
export const createSelectStyles = (dotFunction: () => any, maxWidth: string = "250px") => ({
  control: (styles: any) => ({ 
    ...styles, 
    maxWidth, 
    width: maxWidth === "max-content" ? "max-content" : "max-content", 
    borderColor: "#e1e7ef"
  }),
  input: (styles: any) => ({ ...styles, ...dotFunction() }),
  placeholder: (styles: any) => ({ ...styles, ...dotFunction() }),
  singleValue: (styles: any) => ({ ...styles, ...dotFunction() }),
});

// Экспортируемые готовые стили
export const colourStylesChannel = createSelectStyles(dotChannel);
export const colourStylesDepartment = createSelectStyles(dotDepartment, "max-content");
export const colourStylesCustomer = createSelectStyles(dotCustomer);
export const colourStylesStatus = createSelectStyles(dotStatus);
export const colourStylesRecruiter = createSelectStyles(dotRecruiter);

// Стили с адаптивной шириной (для разных вкладок)
export const colourStylesStatusAdaptive = createSelectStyles(dotStatus, "12vw");
export const colourStylesRecruiterAdaptive = createSelectStyles(dotRecruiter, "12vw");
export const colourStylesCustomerAdaptive = createSelectStyles(dotCustomer, "12vw");
